module.exports = __webpack_public_path__ + "img/backup.40c47fc3.png";